import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import img from "../Assets/Group 18111.png";
import img2 from "../Assets/career.png";
import { baseUrl } from "../Common/data.js";
import ig5 from '../Assets/12145584_Wavy_Edu-03_Single-01.jpg'


const jobListings = [
  {
    title: "ASIC RTL Design Engineer",
    experience: "2 to 15+ years",
    location: "Bangalore",
    jobDescription: [
      "Strong experience in RTL coding using Verilog/System Verilog.",
      "Strong basics of digital design.",
      "Should be capable of defining the Microarchitecture specification from the High Level Architecture spec.",
      "Should have done at least one IP development from the scratch.",
      "Sound knowledge of front end design tools and flows.",
      "Good experience in Synthesis, Lint, CDC, RDC, LEC.",
      "Knowledge of niche protocols such as Ethernet, PCIe, DDR, AMBA etc. is a plus.",
      "Knowledge of Low power RTL design is an advantage.",
      "Good communication skills and a team player."
    ]
  },
  {
    title: "RTL Design Engineer Intern",
    experience: "Freshers/Experience",
    location: "Bangalore",
    jobDescription: [
      "Strong experience in RTL coding using Verilog/System Verilog.",
      "Strong basics of digital design.",
      "Should be capable of defining the Microarchitecture specification from the High Level Architecture spec.",
      "Should have done at least one IP development from the scratch.",
      "Sound knowledge of front end design tools and flows."
    ]
  },
  {
    title: "Low Power Design Engineer",
    experience: "8+ years",
    location: "Bangalore or Hyderabad",
    qualifications: [
      "Bachelor’s or Master’s degree in Electrical Engineering or related field (BE/BTech/M.E/M.Tech)",
      "Excellent communication skills, both verbal and written"
    ],
    skills: [
      "In-depth understanding of power gating and power management techniques",
      "Familiarity with AXI and SMN protocols",
      "Previous experience with AMD is advantageous"
    ],
    jobCategory: "VLSI (Silicon engineering)",
    jobType: "Full Time"
  },
  {
    title: "FPGA RTL Design Engineer",
    experience: "2 - 15 Years",
    location: "Bangalore, Hyderabad, Noida",
    education: "BTECH/MTECH in Electrical/Electronics/Computer Science Engineering or Equivalent",
    skills: [
      "Good Experience with Xilinx FPGA.",
      "Should be well aware of RTL logic.",
      "Well versed with Vivado tool and associated IPs",
      "Well versed with LUT considerations in FPGA design",
      "Well versed with FPGA simulation and testing methods",
      "Well versed with FPGA debug using Xilinx JTAG debugger"
    ]
  },
  {
    title: "RTL & Synthesis Engineer",
    experience: "2 to 8 years or 8+ years",
    location: "Bangalore or Hyderabad",
    qualifications: [
      "Bachelor’s or Master’s degree in Electrical Engineering or related field (BE/BTech/M.E/M.Tech)",
      "Excellent communication skills"
    ],
    responsibilities: [
      "Understand ASIC flow and collaborate with DV, DFT, Synthesis/Implementation, and PD teams",
      "Take on Technical Manager role while remaining hands-on"
    ],
    skills: [
      "RTL coding (Verilog), IP design, RTL integration",
      "Hands-on with LINT, CDC, RDC",
      "Writing UPFs and CLP/VCLP checks",
      "Knowledge of ARM protocols, PCIe, Ethernet, RISC V, DDR",
      "Strong scripting knowledge"
    ]
  },
  {
    title: "Design Verification Engineer Intern",
    experience: "0 years",
    location: "Bangalore",
    jobDescription: [
      "Basic experience in SV/UVM",
      "Strong digital design basics",
      "Defining verification plan and test bench architecture",
      "Constraint random and assertion-based verification",
      "IP and SoC level verification",
      "Functional and Code coverage"
    ]
  },
  {
    title: "Design Verification (DV) Engineer",
    experience: "2 to 15+ years",
    location: "Bangalore",
    jobDescription: [
      "SV/UVM test bench development",
      "Strong digital design and debug skills",
      "Constraint random and assertion-based verification",
      "Knowledge of protocols like Ethernet, PCIe, CXL, DDR, USB, AMBA",
      "Scripting knowledge (Perl, Python)"
    ]
  },
  {
    title: "Post Silicon Validation Engineer",
    experience: "2 to 10 years",
    location: "Bangalore, Hyderabad, Noida",
    education: "BTECH/MTECH in Electrical/Electronics/Computer Science Engineering or Equivalent",
    jobDescription: [
      "ARM processor architecture knowledge",
      "Hands-on C/Assembly coding",
      "Validation test plan execution",
      "Embedded system debugging"
    ]
  },
  {
    title: "Pre-Silicon Validation Engineer",
    experience: "2 to 10 years",
    location: "India",
    qualification: "B.E / B. Tech / M.E / M. Tech",
    jobDescription: [
      "Creating validation environments for firmware",
      "Debug silicon issues pre-silicon",
      "Expertise in SoC development/verification using Verilog/SystemVerilog",
      "Validation planning and debug"
    ]
  },
  {
    title: "Low Power Verification Engineer",
    experience: "8+ years",
    location: "Bangalore or Hyderabad",
    qualification: "B.E / B.Tech / M.E / M.Tech",
    skills: [
      "UPF-based verification",
      "Power gating and power management",
      "Protocols: AXI, SMN",
      "AMD experience is a plus"
    ]
  },
  {
    title: "DFx Engineer",
    experience: "1 to 3 years",
    location: "Bangalore",
    jobDescription: [
      "RTL DFT Verification",
      "Understanding JTAG IEEE-1149.1/IJTAG IEEE P1687",
      "UVM and Verdi usage",
      "Scripting (TCL/Perl)"
    ]
  },
  {
    title: "DFT Engineer",
    experience: "2 to 15+ years",
    location: "Bangalore",
    jobDescription: [
      "DFT architecture, Scan, ATPG, MBIST, JTAG",
      "DFT IP verification",
      "Scripting (Perl, Python)",
      "ATE pattern debug"
    ]
  },
  {
    title: "Emulation Engineer",
    experience: "2 to 5 years",
    location: "India",
    qualification: "B.E / B. Tech / M.E / M. Tech",
    jobDescription: [
      "Palladium, Veloce, Zebu platforms",
      "Verilog/VHDL, C/C++, UVM, Perl/Python",
      "Emulation environment support",
      "Collaborate with design, DV, validation teams"
    ]
  },
  {
    title: "Physical Design Engineer",
    experience: "2 to 15+ years",
    location: "Bangalore",
    jobDescription: [
      "Floorplanning, placement, CTS, routing",
      "PPA optimization",
      "Timing closure, DRC, LVS",
      "Advanced nodes (7nm, 5nm, 3nm)",
      "Cadence/Synopsys/Mentor tool usage"
    ]
  },
  {
    title: "STA Engineer",
    experience: "2 to 15+ years",
    location: "Bangalore",
    jobDescription: [
      "Static Timing Analysis (STA)",
      "SDC constraint development",
      "PnR timing closure",
      "Tools: PrimeTime, Tempus",
      "CDC analysis and MMMC"
    ]
  },
  {
    title: "Analog Circuit Design Engineer",
    experience: "2 to 6 years",
    location: "Bangalore",
    jobDescription: [
      "CMOS circuit design",
      "Power management: LDO, Bandgap, Comparators",
      "High-speed interface: SerDes, DDR, PCIe",
      "Signal Analysis, Compensation",
      "Cadence/Synopsys for schematic and verification"
    ]
  },
  {
    title: "Embedded Test Engineer",
    experience: "2 to 10 years",
    location: "India",
    qualification: "B.E / B. Tech / M.E / M. Tech",
    jobDescription: [
      "Black/white box testing in WLAN, BT, Video, Display",
      "Execute test plans, automation, lab hardware",
      "802.11 protocol testing",
      "Tools: Omnipeek, Wireshark",
      "Scripting: Python, automation frameworks"
    ]
  },
  {
    title: "WLAN Dev Generic",
    experience: "2 to 4 years",
    location: "Bangalore",
    jobDescription: [
      "Strong C programming",
      "LSP, 802.11xx protocol knowledge",
      "WiFi firmware development (Atheros chipset preferred)"
    ]
  }
];

function Career() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${baseUrl}/api/job-post/active`)
      .then((response) => response.json())
      .then((data) => {
        setData(data?.data || []); // Ensure data is an array
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching career data:", error);
        setLoading(false);
      });
  }, []);

  console.log(data);
 const [pdf, setPdf] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setPdf(selectedFile);
    } else {
      alert('Please select a valid PDF file.');
      e.target.value = ''; // reset the file input
    }
  };

  const handleUpload = () => {
    if (pdf) {
      const formData = new FormData();
      formData.append('file', pdf);

      // Replace with your actual upload URL
      fetch('/upload-endpoint', {
        method: 'POST',
        body: formData,
      })
        .then(res => res.json())
        .then(data => {
          alert('PDF uploaded successfully!');
        })
        .catch(err => {
          alert('PDF upload failed.');
        });
    } else {
      alert('No PDF file selected.');
    }
  };
  return (
    <>
      <Navbar />
      <div className="AboutUs-banner">
        <h3>Career</h3>
        <p>Customized ASIC & SOC Solutions with Optimized Cost</p>
      </div>
      <div className="carrerheading">
        <p>From Startup To Industry Leader</p>
        <h3>
          Semicave: Accelerating the
          <br /> future of semicunductors
        </h3>
      </div>
      <div className="career-desc">
        <div className="career-desc-left">
          <img src={img} />
        </div>
        <div className="career-desc-right">
        <h3>Connecting Talent with the Right Opportunities</h3>
        <br/>
          <p>
            Join us as we take you behind the scenes of Semicave, where speed
            isn’t just a preference, it’s a way of life. Semicave is setting the
            benchmark for speed and growth in the semiconductor industry.
            <br />
            <br />
            The company’s commitment to excellence is evident in every facet of
            its operations. Meet the dynamic individuals behind Semicave’s
            success, who emphasize the company’s unique approach of moving fast
            in small teams, avoiding bureaucracy, and fostering a culture of
            continuous growth.
            <br />
            <br />
            Hear firsthand from team members who started as interns or
            recruiters and have now risen to leadership positions, showcasing
            the company’s commitment to nurturing talent. Witness the journey of
            Semicave through the eyes of employees who have been with the
            company for around a century collectively. From its humble
            beginnings as a startup to becoming India’s fastest-growing
            Semiconductor Service Provider, Semicave’s story is nothing short of
            inspiring.
          </p>
          <br/>
          <h5>We're always open to fresh talent! Share your resume with us at <b>hr@semicave.com</b> and take the first step towards an exciting opportunity.</h5>
        <br/>

          <button>Join Us</button>
        </div>
      </div>
  <div className="open-job-section">
  {jobListings.map((job, index) => (
    <div className="open-job-box" key={index}>
      <div className="open-job-box-left">
        <h3>{job.title}</h3>

        <div className="job-info">


          {job.responsibilities && (
            <>
              <h4>Responsibilities:</h4>
              <ul>
                {job.responsibilities.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </>
          )}

          {job.skills && (
            <>
              <h4>Skills:</h4>
              <ul>
                {job.skills.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </>
          )}

          {job.jobDescription && (
            <>
              <h4>Job Description:</h4>
              <ul>
                {job.jobDescription.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </>
          )}

          {job.qualifications && (
            <>
              <h4>Qualifications:</h4>
              <ul>
                {job.qualifications.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </>
          )}
        </div>
        <div className="job-requirnment">
 <div className="job-requirnment-box">
<p><i class="bi bi-clock-history"></i>Exp: {job.experience}</p>
 </div>    
  <div className="job-requirnment-box">
<p><i class="bi bi-geo-alt-fill"></i>{job.location}</p>
 </div> 
 
 </div>    
      </div>

      <div className="open-job-box-right">
       <a href="mailto:hr@semicave.com" style={{ textDecoration: 'none', color: 'inherit' }}>
  <h3>Apply Now <i className="bi bi-arrow-right"></i></h3>
</a>
      </div>
    </div>
  ))}
</div>

      {/* <div className="carrer-form">
  <div className="carrer-form-left">
  <div className="form">
  <h3>Your Career Starts Here <br/>Step into Success</h3>
<br/>
<br/>
<label>Name</label>
<input placeholder="Enter Your Name"/>
<br/>
<label>Email</label>
<input placeholder="Enter Your Email"/>
<br/>
<label>Mobile No.</label>
<input placeholder="Enter Your Mobile No."/>
<br/>
<label>Message</label>
<textarea placeholder="Enter Your Message"/>

<br/>
<label>Resume</label>

 <div>
      
      <input type="file" accept="application/pdf" onChange={handleFileChange} />
     
      
    </div>


<button  onClick={handleUpload}>Submit</button>
  </div>

      </div>
        <div className="carrer-form-right">
<img src={ig5}/>
      </div>
      </div> */}
      {/* <div className="WeHaveEndless">
        <div className="services-heading">
          <p>We Have Endless</p>
          <h3>
            Inspiring growth possibilities.
            <br /> Be a part of people-centric work culture
          </h3>
        </div>
        <br />
        <br />
        <img src={img2} />
        <div className="hiring-boxs">
          {loading ? (
            <p>Loading job openings...</p>
          ) : data.length === 0 ? (
            <p>No job openings available at the moment.</p>
          ) : (
            data.map((job) => (
              <div key={job._id} className="hiring-box">
                <div className="hiring-box-title">
                  <p>{job.title}</p>
                </div>
                <br />
                
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: "10px",
                    important: true
                  }}
                >
                  <p>
                    <strong>Company:</strong> {job.company}
                  </p>
                  <p>
                    <strong>Location:</strong> {job.location}
                  </p>
                  <p>
                    <strong>Type:</strong> {job.jobType}
                  </p>
                  <p>
                    <strong>Salary:</strong> ₹{job.salary}
                  </p>
                  <p>
                    <strong>Description:</strong> {job.description}
                  </p>
                </div>
                <br />
                <div>
                  <strong>Requirements:</strong>
                  <ul>
                    {job.requirements.map((req, index) => (
                      <li key={index}>{req}</li>
                    ))}
                  </ul>
                </div> */}
                {/* <p>
                  <em>
                    Posted on: {new Date(job.createdAt).toLocaleDateString()}
                  </em>
                </p> */}
              {/* </div>
            )) */}
          {/* )} */}
          {/* <div className="hiring-box">
            <div className="hiring-box-title">
              <p>Fresher Hiring</p>
            </div>
            <br />
            <br />
            <br />
            <h5>
              We're experts in nurturing talent and believe in empowering our
              employees to excel. At Semicave, we embrace the diverse talents of
              our team and foster a collaborative, creative, and innovative
              environment. Join Semicave and watch your career take off. With
              our support and your talent, the possibilities are endless.
            </h5>
          </div> */}
          {/* <div className="hiring-box">
            <div className="hiring-box-title">
              <p>Fresher Hiring</p>
            </div>
            <br />
            <br />
            <br />
            <h5>
              We're experts in nurturing talent and believe in empowering our
              employees to excel. At Semicave, we embrace the diverse talents of
              our team and foster a collaborative, creative, and innovative
              environment. Join Semicave and watch your career take off. With
              our support and your talent, the possibilities are endless.
            </h5>
          </div> */}
        {/* </div>
      </div> */}

      <Footer />
    </>
  );
}

export default Career;
